import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getPlanVsActualReport = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_PLAN_VS_ACTUAL_REPORT}`,{params:param});
   // console.log('response--------------->',response.data)
   const rowData = await response?.data;

//    console.log('rowData------------plan--Pagination-------',rowData?.data.Pagination);
//    console.log('rowData------------plan---------',rowData?.data.PlanVsActualReportData);

   const formatedData = Array.isArray(rowData?.data.PlanVsActualReportData)?
   rowData?.data.PlanVsActualReportData.map((item:any)=>({
        EmployeeCode:item.EmployeeCode,
        EmployeeName:item.Name,
        AttendanceDate:item.AttendanceDate,
        PlannedCall:item.PlannedCall,
        CompletedCall:item.CompletedCalls
      })):[];  
      
    console.log('formatedData',formatedData);

  return {formatedData,rowData};
}
   